module.exports = __webpack_public_path__ + "static/img/ic_launcher_round.5a2e365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_launcher_round.png
// module id = apV+
// module chunks = 4